import { format } from 'date-fns';
import type { ChatDocument } from '@/store';

export function formatChatDocumentMetadata(doc: Pick<ChatDocument, 'uploadedAt' | 'sizeMb'>): string | undefined {
  const segments: string[] = [];

  if (doc.uploadedAt) {
    const parsed = new Date(doc.uploadedAt);
    if (!Number.isNaN(parsed.getTime())) {
      segments.push(format(parsed, 'HH:mm d MMM yyyy'));
    } else {
      segments.push(doc.uploadedAt.trim());
    }
  }

  if (doc.sizeMb != null && Number.isFinite(doc.sizeMb)) {
    segments.push(`${doc.sizeMb.toFixed(2)} MB`);
  }

  if (segments.length === 0) {
    return undefined;
  }

  return segments.join('  ');
}
